export default [
  {
    path: '/quest-sequence',
    component: () => import('./views/Index'),
    name: 'quest-sequence',
    redirect: { name: 'quest-sequence-list' },
    children: [
      {
        path: '',
        name: 'quest-sequence-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'auth',
        },
      },
      {
        path: 'detail/:sequence_id',
        name: 'quest-sequence-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'auth',
        },
      },
    ],
  },
]
